
export const uploadWithXHR = async (url, blob) => {
    // XMLHttpRequest approach for better iOS compatibility
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.upload.addEventListener('progress', (e) => {
            if (e.lengthComputable) {
                const percentComplete = (e.loaded / e.total) * 100;
            }
        });

        xhr.addEventListener('load', () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr);
            } else {
                reject(new Error(`Upload failed with status: ${xhr.status}`));
            }
        });

        xhr.addEventListener('error', () => {
            reject(new Error('Upload failed - network error'));
        });

        xhr.addEventListener('abort', () => {
            reject(new Error('Upload was cancelled'));
        });

        xhr.open('PUT', url);
        xhr.setRequestHeader('Content-Type', 'application/pdf');

        // Set timeout (important for iOS)
        xhr.timeout = 120000; // 2 minutes

        xhr.send(blob);
    });
};
